'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "offsetBottom", "offsetTop", "style"];
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useContext, useEffect, useRef } from 'react';
import { ModalContext } from '../context/ModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
const UIDialogHeaderImage = props => {
  const {
      className,
      offsetBottom,
      offsetTop,
      style
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    headerCallback
  } = useContext(ModalContext);
  const elRef = useRef(null);
  useEffect(() => {
    const updateHeaderOffset = () => {
      // Measuring offsetTop in the DOM is more accurate than using the offsetTop prop, because it
      // accounts for the padding above the element.
      const overflow = -1 * elRef.current.offsetTop;
      if (overflow > 0) {
        headerCallback(overflow);
      }
    };
    updateHeaderOffset();
    addEventListener('resize', updateHeaderOffset);
    return () => {
      removeEventListener('resize', updateHeaderOffset);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
    className: classNames('private-modal__header-image', className),
    ref: elRef,
    style: Object.assign({
      marginBottom: offsetBottom,
      marginTop: offsetTop != null && offsetTop * -1
    }, style)
  }));
};
UIDialogHeaderImage.propTypes = {
  children: PropTypes.node,
  offsetBottom: PropTypes.number,
  offsetTop: PropTypes.number
};
UIDialogHeaderImage.displayName = 'UIDialogHeaderImage';
export default UIDialogHeaderImage;